import React from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    makeStyles,
    responsiveFontSizes,
} from "@material-ui/core";

import StarIcon from "@material-ui/icons/Stars";
import StarsOutlinedIcon from "@material-ui/icons/StarsOutlined";
import { StarOutlineOutlined } from "@material-ui/icons";

const useStyles = makeStyles(() => ({
    marginBetween: {
        marginTop: "-2em",
        
    },
    colorPopUp:{
        backgroundColor: "wheat",
        fontSize:"2rem"
    },
    awardIcon: {
        transform: "scale(4)",
        margin: "10%",
    },
    awardContainer: {
        overflow: "hidden",
    },
}));

const awardList = [
    {
        awardName: "a",
        won: true,
    },
    {
        awardName: "b",
        won: false,
    },
    {
        awardName: "c",
        won: false,
    },
    {
        awardName: "d",
        won: false,
    },
    {
        awardName: "e",
        won: true,
    },
    {
        awardName: "f",
        won: true,
    },
    {
        awardName: "g",
        won: true,
    },
    {
        awardName: "h",
        won: false,
    },
    {
        awardName: "i",
        won: false,
    },
    {
        awardName: "j",
        won: false,
    },
    {
        awardName: "k",
        won: true,
    },
    {
        awardName: "l",
        won: true,
    },
    {
        awardName: "m",
        won: true,
    },
    {
        awardName: "n",
        won: false,
    },
    {
        awardName: "o",
        won: false,
    },
    {
        awardName: "p",
        won: false,
    },
    {
        awardName: "q",
        won: true,
    },
    {
        awardName: "r",
        won: true,
    },
];

function ShowIcon(props: { handleClickOpen: React.MouseEventHandler; won: any; }) {
    const classes = useStyles();
    const won = props.won;
    if (won) {
        return (
            <div className={`${classes.awardIcon}`} onClick={props.handleClickOpen}>
                <StarIcon />
            </div>
        );
    }
    return (
        <div className={`${classes.awardIcon}`} onClick={props.handleClickOpen}>
            <StarsOutlinedIcon />
        </div>
    );
}


export default function Awards(): JSX.Element {

    const classes = useStyles();

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    return (
        <>
            <div className={`${classes.marginBetween}`}>
                <Grid container direction="column" justify="space-evenly">
                    <Grid container justify="space-around" className={`${classes.awardContainer}`}>
                        {awardList.map((item) => (
                            <ShowIcon key={item.awardName} won={item.won} handleClickOpen={handleClickOpen} />
                        ))}
                        <Grid container direction="row" justify="space-around" />
                    </Grid>
                </Grid>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title" className={`${classes.colorPopUp}`}>
                        {"Missão 1  🎯"}
                    </DialogTitle>
                    <DialogContent className={`${classes.colorPopUp}`}>
                        <DialogContentText id="alert-dialog-description">
                            Ganhou 10 Desafios contra um amigo 🤙🏾
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions className={`${classes.colorPopUp}`}>
                        <Button onClick={handleClose}>Fechar ❌</Button>
                    </DialogActions>
                </Dialog>
            </div>
        </>
    );

    /*return (
        <div className={`${classes.marginBetween}`}>
            <Grid container direction="column" justify="space-evenly">
                <Grid container justify="space-around" className={`${classes.awardContainer}`}>
                    {awardList.map((item) => (
                        <ShowIcon key={item.awardName} won={item.won} />
                    ))}
                    <Grid container direction="row" justify="space-around" />
                </Grid>
            </Grid>
        </div>
    );*/
}
